import React, { useMemo } from 'react';

const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const getDaysInMonth = (month, year) => {
   return new Date(year, month + 1, 0).getDate();
};

const getFirstDayOfMonth = (month, year) => {
   const day = new Date(year, month, 1).getDay();
   return day === 0 ? 6 : day - 1;
};

const formatDateString = (day, month, year) => {
   const d = String(day).padStart(2, '0');
   const m = String(month + 1).padStart(2, '0');
   return `${year}-${m}-${d}`;
};

const isToday = (day, month, year) => {
   const today = new Date();
   return (
      day === today.getDate() &&
      month === today.getMonth() &&
      year === today.getFullYear()
   );
};

const CalendarGrid = ({ currentMonth, currentYear, entries, selectedDate, onDateSelect }) => {
   const hasEntry = (dateString) => {
      return entries.some(entry => entry.date === dateString);
   };

   const calendarDays = useMemo(() => {
      const daysInMonth = getDaysInMonth(currentMonth, currentYear);
      const firstDay = getFirstDayOfMonth(currentMonth, currentYear);
      const days = [];

      const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
      const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
      const daysInPrevMonth = getDaysInMonth(prevMonth, prevYear);

      for (let i = firstDay - 1; i >= 0; i--) {
         const day = daysInPrevMonth - i;
         days.push({
            day,
            month: prevMonth,
            year: prevYear,
            isCurrentMonth: false,
            dateString: formatDateString(day, prevMonth, prevYear),
         });
      }

      for (let day = 1; day <= daysInMonth; day++) {
         days.push({
            day,
            month: currentMonth,
            year: currentYear,
            isCurrentMonth: true,
            dateString: formatDateString(day, currentMonth, currentYear),
         });
      }

      const nextMonth = currentMonth === 11 ? 0 : currentMonth + 1;
      const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
      const remainingDays = 42 - days.length;

      for (let day = 1; day <= remainingDays; day++) {
         days.push({
            day,
            month: nextMonth,
            year: nextYear,
            isCurrentMonth: false,
            dateString: formatDateString(day, nextMonth, nextYear),
         });
      }

      return days;
   }, [currentMonth, currentYear]);

   return (
      <>
         <div className="calendar-weekdays">
            {DAYS_OF_WEEK.map(day => (
               <div key={day} className="weekday">
                  {day}
               </div>
            ))}
         </div>

         <div className="calendar-grid">
            {calendarDays.map((dayInfo, index) => {
               const entryExists = hasEntry(dayInfo.dateString);
               const isTodayDate = isToday(dayInfo.day, dayInfo.month, dayInfo.year);
               const isSelected = selectedDate === dayInfo.dateString;

               return (
                  <div
                     key={index}
                     className={`calendar-day ${!dayInfo.isCurrentMonth ? 'other-month' : ''} ${
                        entryExists ? 'has-entry' : ''
                     } ${isTodayDate ? 'today' : ''} ${isSelected ? 'selected' : ''}`}
                     onClick={() => onDateSelect(dayInfo.dateString, entryExists)}
                  >
                     <span className="day-number">{dayInfo.day}</span>
                     {entryExists && <div className="entry-indicator" />}
                  </div>
               );
            })}
         </div>
      </>
   );
};

export default CalendarGrid;
